import React from 'react';
import { Box, PaletteMode, createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { Background } from '../components/Background';
import { Skill } from '../components/Skill';
import AppAppBar from '../components/AppAppBar';
// import getLPTheme from '../components/utilis/getLPTheme';
import Introduction from '../components/Introduction';
import Projects  from '../components/Projects';

export const LandingPage: React.FC = ()=>{
  const [mode, setMode] = React.useState<PaletteMode>('dark');
  const defaultTheme = createTheme({ palette: { mode } });
  // const LPtheme = createTheme(getLPTheme(mode));
  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  return(
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline/>
        <AppAppBar mode={mode} toggleColorMode={toggleColorMode}/>
        <Introduction/>
        <Box sx={{bgcolor: 'background.default'}}>
            <Projects/>
            <Background/>
            <Skill/>
        </Box>
    </ThemeProvider>
  )
}